import React from 'react'
import { useTranslation } from 'react-i18next'

export const PageLength = ({
    handlePageLength, pageLength,
    total
}) => {

    const { t } = useTranslation();

    return (
        <div className="result-foot d-flex align-items-center gap-1">
            <span> {t("pagelength.showing")} </span>
            <span
                className="filter-action-count-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers"
                id="filter-count-action-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                {pageLength}
            </span>
            <ul
                className="filter-dropdown-menu dropdown-menu"
                aria-labelledby="filter-action-count-dropdown"
            >
                {[10, 25, 50, 100].map((value) => (
                    <li
                        key={value}
                        className="filter-dropdown-item"
                        onClick={() => handlePageLength(value)}
                    >
                        {value}
                    </li>
                ))}
            </ul>
            <span>{t("pagelength.of")} {total} {t("pagelength.records")}</span>
        </div>
  )
}
